/* src/app/intro/intro-start/intro-start.component.scss */
.title {
  font-size: 10vw;
}
@media (min-width: 810px) {
  .title {
    font-size: 90px;
  }
}
/*# sourceMappingURL=intro-start.component.css.map */
